import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { listFollowups, logFollowup } from "@/api/followups";

const FOLLOWUPS_QUERY_KEY = ["followups"] as const;

export function useFollowups() {
  return useQuery({
    queryKey: FOLLOWUPS_QUERY_KEY,
    queryFn: listFollowups,
    staleTime: 30_000,
  });
}

export function useLogFollowup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: logFollowup,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: FOLLOWUPS_QUERY_KEY });
    },
  });
}
